/** The fixed lock reasons, mirroring `LOCK_REASONS` in core, in the order the lock dialog lists them. */
export const LOCK_REASONS = [
  "user_request",
  "manual",
  "kyc_declined",
  "kyc_duplicate",
  "suspected_fraud",
  "dispute",
] as const;
export type LockReason = (typeof LOCK_REASONS)[number];

export const LOCK_REASON_LABELS: Record<LockReason, string> = {
  user_request: "User request",
  manual: "Manual",
  kyc_declined: "Identity verification declined",
  kyc_duplicate: "Duplicate identity",
  suspected_fraud: "Suspected fraud",
  dispute: "Payment dispute",
};

export function isLockReason(value: unknown): value is LockReason {
  return typeof value === "string" && (LOCK_REASONS as readonly string[]).includes(value);
}

/** The label for a stored code; a lock that predates the list has none and reads as a dash. */
export function lockReasonLabel(code: string | null | undefined): string {
  return isLockReason(code) ? LOCK_REASON_LABELS[code] : "—";
}
